import PropTypes from 'prop-types'

import { cn } from '@/utils/helpers'

function AnswerInput({ value }) {
  return (
    <div
      className={cn(
        'mx-2 min-h-[2em] min-w-10 rounded border px-2 py-2',
        'bg-secondary inline-block',
      )}
    >
      {value}
    </div>
  )
}
AnswerInput.propTypes = {
  value: PropTypes.string.isRequired,
}

function DragAndDropQuestion({ question, field }) {
  // Map [null, "word", null] to [0, "word", 1] so we can track which field to update
  const { templateToAnswerArray } = question.answers.template.reduce(
    (acc, curr) => {
      if (curr === null) {
        acc.templateToAnswerArray.push(acc.index)
        acc.index += 1
      } else acc.templateToAnswerArray.push('phrase')
      return acc
    },
    { index: 0, templateToAnswerArray: [] },
  )

  return (
    <div className="flex gap-2">
      <div className="max-w-lg">
        {question.answers.template.map((answer, index) => {
          if (answer === null) {
            const fieldIndex = templateToAnswerArray[index]
            const correctAnswer = question.correctAnswers[fieldIndex]
            const response = field?.value?.[fieldIndex] || ''
            const isCorrect = response === correctAnswer

            return (
              <div
                className={cn(
                  'mx-2 min-h-[2em] min-w-10 rounded border px-2 py-2',
                  'bg-secondary inline-block',
                )}
              >
                <span className={isCorrect ? '' : 'text-destructive line-through'}>
                  {response}
                </span>
                {!isCorrect && <span className="text-success ml-2">({correctAnswer})</span>}
              </div>
            )
          }
          // Template is static, and may contain duplicate answer strings
          // eslint-disable-next-line react/no-array-index-key
          return <span key={`${answer}-${index}}`}>{answer}</span>
        })}
      </div>
    </div>
  )
}

export default DragAndDropQuestion

DragAndDropQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
}
